module.exports = __webpack_public_path__ + "img/disperse-icon-02.b417b8e1.png";